import * as types from '../../mutation_type'
import { setCookie } from '../../../../util/util'
// import bus from '../../../../buses'
export default {
  [types.LOGINBYACCOUNT] (state, res) {
    state.userInfo = res.data.data
     setCookie('username', res.data.data.username, 0.192)
     setCookie('nickname', res.data.data.nickname, 0.192)
     setCookie('memberid', res.data.data.memberid, 0.192)
     setCookie('mlevelcode', res.data.data.mlevelcode, 0.192)
     setCookie('mdiscount', res.data.data.mdiscount, 0.192)
     setCookie('imore', res.data.data.imore, 0.192)
     setCookie('freticketnum', res.data.data.freticketnum, 0.192)
     setCookie('openshare', res.data.data.openshare, 0.192)
     setCookie('sex', res.data.data.sex, 0.192)
     setCookie('mphone', res.data.data.mphone, 0.192)
     setCookie('email', res.data.data.email, 0.192)
     setCookie('cbalance', res.data.data.cbalance, 0.192)
     setCookie('hpurl', res.data.data.hpurl, 0.192)
     setCookie('birthday', res.data.data.birthday, 0.192)
     setCookie('ibalance', res.data.data.ibalance, 0.192)
     setCookie('emailcheck', res.data.data.emailcheck, 0.192)
     setCookie('mphonecheck', res.data.data.mphonecheck, 0.192)
  },
  [types.REGISTERBYACCOUNT] (state, res) {
    state.login_user = res.data
    state.checkErrorMessage = res.data.message
  },
  [types.GETCHECKCODETOREGISTER] (state, res) {
    if (res.data.status !== '001') {
      state.checkErrorMessage = res.data.message
    }
  },
  [types.LOGINORREGISTERINITBYWX] (state, res) {
    state.qcodeurl = res.data.QRurl
    state.uniqcode = res.data.unicode
  },
  [types.LOGINORREGISTERBYWX] (state, res) {
     if (res.data.membercode) {
      console.log(res)
      state.showWxLoginSuccess = true
      state.canIndexPush = true
      state.userInfo = res.data
       setCookie('username', res.data.data.username, 0.192)
       setCookie('nickname', res.data.data.nickname, 0.192)
       setCookie('memberid', res.data.data.memberid, 0.192)
       setCookie('mlevelcode', res.data.data.mlevelcode, 0.192)
       setCookie('mdiscount', res.data.data.mdiscount, 0.192)
       setCookie('imore', res.data.data.imore, 0.192)
       setCookie('freticketnum', res.data.data.freticketnum, 0.192)
       setCookie('openshare', res.data.data.openshare, 0.192)
       setCookie('sex', res.data.data.sex, 0.192)
       setCookie('mphone', res.data.data.mphone, 0.192)
       setCookie('email', res.data.data.email, 0.192)
       setCookie('cbalance', res.data.data.cbalance, 0.192)
       setCookie('hpurl', res.data.data.hpurl, 0.192)
       setCookie('birthday', res.data.data.birthday, 0.192)
       setCookie('ibalance', res.data.data.ibalance, 0.192)
       setCookie('emailcheck', res.data.data.emailcheck, 0.192)
       setCookie('mphonecheck', res.data.data.mphonecheck, 0.192)
    }
  },
  [types.CHECKACCOUNTVAL] (state, res) {
    state.registering = res.data.data
    state.registerings = res.data.message
    setCookie('mphone', res.data.data.mphone, 0.192)
    setCookie('email', res.data.data.email, 0.192)
  },
  [types.GETMEMBERINFO] (state, res) {
    state.userInfo = res.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/login/mutations/mutation.js